import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import { getKapitiTransactions, getAppTitle, getAccountId } from '../../states/kapitiTransactions/selectors';
import { fetchKapitiTransactions } from '../../states/kapitiTransactions/actions';
import { getBankId } from '../../states/session/selectors';

const mapState = (state) => ({
	kapitiTransactions: getKapitiTransactions(state),
	appTitle: getAppTitle(state),
	bankId: getBankId(state),
	accountId: getAccountId(state),
});

const mapDispatch = (dispatch) => ({
	fetchKapitiTransactions: (appTitle, bankId, accountId) =>
		dispatch(fetchKapitiTransactions(appTitle, bankId, accountId)),
});

const columns = [
	{
		title: 'Date',
		id: 'date',
		path: ['date'],
	},
	{
		title: 'Description',
		id: 'description',
		path: ['description'],
	},
	{
		title: 'Amount',
		id: 'amount',
		path: ['amount'],
		alignment: 'right',
	},
	{
		title: 'Balance',
		id: 'balance',
		path: ['balance'],
		alignment: 'right',
	},
];

class KapitiTransactions extends Component {
	componentDidMount() {
		const { fetchKapitiTransactions, appTitle, bankId, accountId } = this.props;

		fetchKapitiTransactions(appTitle, bankId, accountId);
	}

	render() {
		const { kapitiTransactions } = this.props;
		return (
			<div>
				{kapitiTransactions.length > 0 && (
					<DataTable
						breakpointSnap="1280"
						isBranded
						layout="transactions"
						columns={columns}
						data={kapitiTransactions}
						keyPath={['id']}
					/>
				)}
			</div>
		);
	}
}
KapitiTransactions.propTypes = {
	kapitiTransactions: PropTypes.shape([{}]),
	fetchKapitiTransactions: PropTypes.func,
	appTitle: PropTypes.string,
	bankId: PropTypes.string,
	accountId: PropTypes.string,
};

export default connect(mapState, mapDispatch)(KapitiTransactions);
